import SentimentFiltersViewModel from "./SentimentFiltersViewModel";
import { Sentiments } from "./Sentiments";

export default class CustomerSentimentFiltersViewModel extends SentimentFiltersViewModel {
    isStartingFrictionEnabled: boolean = false;
    startingFriction: string[] = [Sentiments[0], Sentiments[8]];
    isMiddleFrictionEnabled: boolean = false;
    middleFriction: string[] = [Sentiments[0], Sentiments[8]];
    isFinalFrictionEnabled: boolean = false;
    finalFriction: string[] = [Sentiments[0], Sentiments[8]];
}